import { app } from '../core/App';
import { Player } from '../Player';
import ChunkBase from './ChunkBase';
import { BodyTypes } from './LevelManager';
import { RunManager } from './RunManager';

export default class TrapImageBase extends Phaser.Physics.Matter.Image {
  public static events = {
    Init: 'init'
  } as const;

  public zIndex: number;

  protected chunk: ChunkBase | undefined;
  protected hasCollided: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: number | string) {
    super(scene.matter.world, x, y, texture, frame, {
      label: BodyTypes.TouchTrap,
      isStatic: true
    });
    this.setOnCollide(this.onCollision.bind(this));

    this.zIndex = 0;

    this.hasCollided = false;
  }

  public init() {
    this.emit(TrapImageBase.events.Init);
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  public reset() {
    this.alpha = 1;
    this.scale = 1;
    this.setVisible(true);
    this.setActive(true);
  }

  public recycle(removeFromChunk: boolean = false) {
    this.scene.tweens.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);

    if (removeFromChunk) this.chunk?.removeTrap(this);
    this.chunk = undefined;
  }

  protected onCollision(pair: MatterJS.IPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyA as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyA as MatterJS.BodyType, (pair.bodyA as MatterJS.BodyType).gameObject);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyB as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyB as MatterJS.BodyType, (pair.bodyB as MatterJS.BodyType).gameObject);
    }
  }

  protected onCollisionWithPlayer(body: MatterJS.BodyType, player: Player) {
    this.hasCollided = true;

    // Player dies on trap.
    console.log('Trap killing player!', player.CurrentCharacter);
    app.audioHandler.playSound(this.scene, 'SndDieBump', 'sfx');
    this.scene.events.emit(RunManager.events.PlayerDeath);
  }
}
